import { z } from "zod";

export const storePolicyTypeSchema = z.enum([
  "GENERAL",
  "RENTAL",
  "CANCELLATION",
  "DEPOSIT",
  "DAMAGE",
  "LATE_RETURN",
  "SHIPPING",
  "PRIVACY",
  "OTHER",
]);

/**
 * Creating a policy of a type that already has an active version creates a
 * new version and deactivates the previous one (docs/business-rules.md
 * §5.2) — this is a single "create" schema, there is no "update" schema.
 */
export const createStorePolicySchema = z.object({
  policyType: storePolicyTypeSchema,
  title: z.string().trim().min(1).max(200),
  content: z.string().trim().min(1),
});
export type CreateStorePolicyInput = z.infer<typeof createStorePolicySchema>;
